/* AMTENDENCY — slider de sugestões do carrinho ("Você também vai gostar").
   - Arrastar com o mouse (clique e arrasta) além do swipe nativo no toque.
   - Sem barra de scroll visível (CSS).
   - Ordem aleatória opcional (data-am-cross-random="1").
   Reinicializa quando o drawer re-renderiza ao atualizar o carrinho. */
(function () {
  function shuffle(row) {
    var items = Array.prototype.slice.call(row.children);
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      row.appendChild(items[j]);
      items.splice(j, 1);
    }
  }

  function initRow(row) {
    if (row.dataset.amCrossInit === '1') return;
    row.dataset.amCrossInit = '1';

    if (row.dataset.amCrossRandom === '1') shuffle(row);

    var down = false, startX = 0, startScroll = 0, moved = false;

    row.addEventListener('mousedown', function (e) {
      down = true; moved = false;
      startX = e.pageX;
      startScroll = row.scrollLeft;
      row.classList.add('is-dragging');
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 4) moved = true;
      row.scrollLeft = startScroll - dx;
      e.preventDefault();
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      row.classList.remove('is-dragging');
      // limpa o flag de "arrastou" no próximo tick (depois do click)
      setTimeout(function () { moved = false; }, 0);
    });
    // impede que o clique navegue se o usuário estava arrastando
    row.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    // evita o "ghost drag" da imagem
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function initAll() {
    document.querySelectorAll('.am-cart-cross__row').forEach(initRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);

  // o cart-drawer-items é substituído ao atualizar o carrinho → re-inicializa
  var cd = document.querySelector('cart-drawer');
  if (cd && 'MutationObserver' in window) {
    new MutationObserver(function () { initAll(); }).observe(cd, { childList: true, subtree: true });
  }
})();
